import { Trans } from '@lingui/react/macro';

import { ActivityOfType } from '@/components/activities/Activity';
import {
  BaseActivity,
  BaseActivityArticleName,
  BaseActivityText,
} from '@/components/activities/BaseActivity/BaseActivity';
import IconEdit from '@/icons/Edit.svg';

export const ArticleQualityControlServiceAdjustedActivity = ({
  activity,
  displayArticleName,
}: {
  activity: ActivityOfType<'article_quality_control_service_adjusted'>;
  displayArticleName: boolean;
}) => {
  const creatorName = activity.creator.name;

  const articleName = (
    <BaseActivityArticleName activity={activity} displayArticleName={displayArticleName} />
  );

  return (
    <BaseActivity
      createdAt={activity.createdAt}
      type="neutral"
      icon={<IconEdit />}
      message={
        <BaseActivityText>
          {displayArticleName ? (
            <Trans id="activities.article_quality_control_service_adjusted.message.with-article">
              <strong>{creatorName}</strong> adjusted the service and actions during quality control
              of the item {articleName}
            </Trans>
          ) : (
            <Trans id="activities.article_quality_control_service_adjusted.message">
              <strong>{creatorName}</strong> adjusted the service and actions during quality control
            </Trans>
          )}
        </BaseActivityText>
      }
    />
  );
};
